import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import i18nBackend from "i18next-http-backend";
import { DEFAULT_LANG } from "../constants/all-language";

// Under Module Federation, shared i18next plugins can arrive via loadShare with the
// CJS/ESM default wrapped (e.g. { default: Backend }), which makes i18next.use() throw
// "You are passing a wrong module". Unwrap the default defensively before .use().
const HttpBackend = (i18nBackend as any)?.default ?? i18nBackend;
const ReactI18next = (initReactI18next as any)?.default ?? initReactI18next;

i18n
  .use(HttpBackend)
  .use(ReactI18next)
  .init({
    fallbackLng: "en", 
    lng: DEFAULT_LANG,
    
    fallbackNS: false, // Don't fallback to other namespaces
    
    returnNull: false,
    returnEmptyString: false,

    interpolation: {
      escapeValue: false,
    },
    debug: false,  // Make sure this is false
    saveMissing: false,
    missingKeyHandler: false,  // Explicitly disable
    missingKeyNoValueFallbackToKey: true,

    resources: {},

    saveMissingTo: 'fallback',
    
    keySeparator: '.',
    nsSeparator: ':',
  });

export default i18n;